import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { translationEN } from "./translations/enTranslations.js";
import { translationSRB } from "./translations/srbTranslations.js";
import { translationRU } from "./translations/ruTranslations.js";
import { translationRO } from "./translations/roTranslations.js";
import { translationUK } from "./translations/ukTranslations.js";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEN,
    },
    sr_latn: {
      translation: translationSRB,
    },
    ru: {
      translation: translationRU,
    },
    ro: {
      translation: translationRO,
    },
    uk: {
      translation: translationUK,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
